import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import FilterTextInput from "./FilterTextInput";
import FilterDatePicker from "./FilterDatePicker";
import FilterMultiSelect from "./FilterMultiSelect";
import FilterBoolean from "./FilterBoolean";
function Filter(props) {
    switch (props.type) {
        case "str":
        case "int":
        case "float":
            return _jsx(FilterTextInput, { ...props });
        case "datetime":
            return _jsx(FilterDatePicker, { ...props });
        case "boolean":
            return _jsx(FilterBoolean, { ...props });
        case "multi":
            return _jsx(FilterMultiSelect, { ...props });
    }
    console.log("Cannot retrieve filter type: " + props.attribute);
    return _jsx(_Fragment, {});
}
export default Filter;
